import {EXTERNAL_ORGANIZATION_API} from '../../../utils/constants';
import type {EncompassExternalOrganizationResponse} from '../models/SubordinateCompany';
import api_access from '../../../api/apiInstance';

export async function fetchExteralOrganizationApi(params:any): Promise<EncompassExternalOrganizationResponse> {
  try {
    const response = await api_access.get(EXTERNAL_ORGANIZATION_API, {params:params});
    return response.data;
  } catch (error) {
    console.error('Error fetching External organizations: ', error);
    throw error;
  }
}

export async function fetchSubOrdinateCompanyFieldApi(loanId:string, params:any): Promise<EncompassExternalOrganizationResponse> {
  try {
    const response = await api_access.get(`/v1/fields/${loanId}/subOrdinateCompany`, {params:params});
    return response.data;
  } catch (error) {
    console.error('Error fetching External organizations: ', error);
    throw error;
  }
}

export async function postSubOrdinateCompany(payload:any): Promise<EncompassExternalOrganizationResponse> {
  try {
    const response = await api_access.post(EXTERNAL_ORGANIZATION_API, payload);
    return response.data;
  } catch (error) {
    console.error('Error fetching External organizations: ', error);
    throw error;
  }
}
